import { useToastMessagesStore } from "@/Stores/ToastMessagesStore";
import { useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import { can } from "@/Util/permissionChecks";
import { useCreateClient } from "@/Service/Api/V1/ApiHooks/Clients/useCreateClient";
import ClientForm, { ClientFormData } from "@/Components/Forms/Form/ClientForm";
import {sleep, url} from "@/Helpers/general";
import {useNavigate} from "react-router-dom";

const CreateClientPage = () => {
    const addToastMessage = useToastMessagesStore((state) => state.addToastMessage);

    const { mutateAsync: createClient, isPending } = useCreateClient();
    const queryClient = useQueryClient();
    const navigate = useNavigate()

    const handleCreateClient = async (data: ClientFormData) => {
        await createClient({
            StoreClientRequest: {
                ...data,
            }
        }, {
            onSuccess: async () => {
                await queryClient.invalidateQueries({
                    queryKey: QueryKeys.users._def
                });
                addToastMessage({
                    severity: 'success',
                    summary: 'Client created',
                    detail: 'Client has been created successfully',
                });
                await sleep(2000);
                navigate(url('clients'));
            },
            onError: async (error) => {
                addToastMessage({
                    severity: 'error',
                    summary: 'Client creation failed',
                    detail: `Client creation failed ${error.message}`,
                });
            }
        });
    };

    return (
        <PageLayout>
            <ClientForm
                onSubmit={handleCreateClient}
                isProcessing={isPending}
                onSubmitButtonLabel='Create client'
                onSubmitButtonDisabled={!can('create:client')}
            />
        </PageLayout>
    );
};

export default CreateClientPage;